import Api from 'shared/core/api'

export default {
  getPois (queryParams) {
    return Api().get('/pois', { params: queryParams });
  }
}
